// src/pages/Auth/index.jsx
import React, { useState } from 'react';
import { Card, Tabs, Form, Input, Button, message } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useNavigate, useLocation } from 'react-router-dom';
import { users } from '../../api/mockData';
import './index.css';

const { TabPane } = Tabs;

const Auth = () => {
  const [activeTab, setActiveTab] = useState('login');
  const [loginForm] = Form.useForm();
  const [registerForm] = Form.useForm();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogin = (values) => {
    const user = users.find(
      u => u.username === values.username && u.password === values.password
    );
    
    if (user) {
      localStorage.setItem('userToken', 'mock-token');
      localStorage.setItem('userInfo', JSON.stringify({
        username: user.username,
        name: user.name,
        avatar: user.avatar,
        role: user.role
      }));
      message.success('登录成功！');
      const from = location.state?.from || '/';
      navigate(from);
    } else {
      message.error('用户名或密码错误');
    }
  };

  const handleRegister = (values) => {
    if (values.password !== values.confirmPassword) {
      message.error('两次密码不一致');
      return;
    }
    
    const userExists = users.some(u => u.username === values.username);
    if (userExists) {
      message.error('用户名已存在');
      return;
    }
    
    message.success('注册成功！请登录');
    setActiveTab('login');
    loginForm.setFieldsValue({ username: values.username });
  };

  return (
    <div className="auth-page">
      <Card className="auth-card">
        <div className="auth-header">
          <h2 className="auth-title">
            <span className="chinese-seal-small">鉴</span>
            文物鉴权
          </h2>
          <p className="auth-subtitle">守护文明，始于身份</p>
        </div>

        <Tabs 
          activeKey={activeTab} 
          onChange={setActiveTab}
          centered
          className="auth-tabs"
        >
          <TabPane tab="登录" key="login">
            <Form form={loginForm} onFinish={handleLogin} className="auth-form">
              <Form.Item
                name="username"
                rules={[
                  { required: true, message: '请输入用户名' },
                  { min: 3, message: '用户名至少3个字符' }
                ]}
              >
                <Input 
                  prefix={<UserOutlined />} 
                  placeholder="用户名" 
                  size="large"
                  className="auth-input"
                />
              </Form.Item>
              
              <Form.Item
                name="password"
                rules={[
                  { required: true, message: '请输入密码' },
                  { min: 6, message: '密码至少6个字符' }
                ]}
              >
                <Input.Password 
                  prefix={<LockOutlined />} 
                  placeholder="密码" 
                  size="large"
                  className="auth-input"
                />
              </Form.Item>
              
              <Form.Item>
                <Button 
                  type="primary" 
                  htmlType="submit" 
                  size="large" 
                  block
                  className="auth-btn"
                >
                  登录
                </Button>
              </Form.Item>
            </Form>
          </TabPane>
          
          <TabPane tab="注册" key="register">
            <Form form={registerForm} onFinish={handleRegister} className="auth-form">
              <Form.Item
                name="username"
                rules={[
                  { required: true, message: '请输入用户名' },
                  { min: 3, message: '用户名至少3个字符' }
                ]}
              >
                <Input 
                  prefix={<UserOutlined />} 
                  placeholder="用户名" 
                  size="large"
                  className="auth-input"
                />
              </Form.Item>
              
              <Form.Item
                name="password"
                rules={[
                  { required: true, message: '请输入密码' },
                  { min: 6, message: '密码至少6个字符' }
                ]}
              >
                <Input.Password 
                  prefix={<LockOutlined />} 
                  placeholder="密码" 
                  size="large"
                  className="auth-input"
                />
              </Form.Item>
              
              <Form.Item
                name="confirmPassword"
                rules={[
                  { required: true, message: '请确认密码' }
                ]}
              >
                <Input.Password 
                  prefix={<LockOutlined />} 
                  placeholder="确认密码" 
                  size="large"
                  className="auth-input"
                />
              </Form.Item>
              
              <Form.Item>
                <Button 
                  type="primary" 
                  htmlType="submit" 
                  size="large" 
                  block
                  className="auth-btn"
                >
                  注册
                </Button>
              </Form.Item>
            </Form>
          </TabPane>
        </Tabs>

        <div className="auth-footer">
          <p>测试账号：文物守护者 / 123456</p>
        </div>
      </Card>
    </div>
  );
};

export default Auth;